var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.687 10.338h0a.813.813 0 00-1.124-1.176h0l-4.939 4.714-2.187-2.089h0a.814.814 0 00-1.124 1.176h0l2.75 2.625h0a.815.815 0 001.123 0h0l5.5-5.25zM6.617 3.945A9.688 9.688 0 0112 2.313 9.699 9.699 0 0121.688 12a9.688 9.688 0 11-15.07-8.055z",
    fill: "#0D814A",
    stroke: "#0D814A",
    strokeWidth: 0.125
  })));
}
export default SvgGreenCheck;